export default {
  path: 'menu',
  component: () => import(/* webpackChunkName: "menu-list" */ '@/pages/menu/MenuList'),
  meta: {title:'菜单管理',cate:'所有系统管理'}
}